import React from 'react';
import { useSelector } from 'react-redux';
import {
  enableBookingPageRevampSelector,
  isPaxSelector,
} from 'selectors/app-selector';
import NewBookingTablePage from './new-booking-table-page';
import OrderHistory from '../order-history';

const BookingTablePageSwitch = props => {
  const isPax = useSelector(isPaxSelector);
  const enableBookingPageRevamp = useSelector(enableBookingPageRevampSelector);

  if (isPax && enableBookingPageRevamp === undefined) {
    // sanity to wait config being fetched
    // to make sure old booking page cycle not started along with revamped
    return null;
  }

  if (isPax && enableBookingPageRevamp) {
    return <NewBookingTablePage {...props} />;
  }

  return <OrderHistory {...props} />;
};

export default BookingTablePageSwitch;
